export default __webpack_public_path__ + "tidying-up.3b1e78db.png";